<div id="page">
  <main>
    <div class="layout-container">
      <aside class="sidebar">
        <div class="settings">
          <hyperkit-typography
            display="inline"
            variant="h3"
            align="center"
            color="primary"
            >Settings</hyperkit-typography
          >
        </div>
        @for (group of sidebarData; track group) {
          <div class="group">
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
              >{{ group.groupTitle }}</hyperkit-typography
            >
            <ul>
              @for (tab of group.items; track tab) {
                <li
                  [routerLink]="tab.routerLink"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <hyperkit-link
                    variant="body"
                    size="md"
                    align="left"
                    color="primary"
                    [text]="tab.menuTitle"
                  >
                  </hyperkit-link>
                </li>
              }
            </ul>
          </div>
        }
        <hyperkit-message
          type="info"
          class="new"
          routerLink="/releases"
          [text]="'Check out what\'s new in Version ' + latest"
        ></hyperkit-message>
      </aside>
      <div class="content-area">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
